module.exports = __webpack_public_path__ + "../resources/images/undo-58b765d014ae5f7e7d3300b5eec92d39.svg";